import { downloadListButton } from "./contactElsSetup.js";
// import { editContactPopover, nameEditInput, orgEditInput, bioEditInput, emailEditInput, phoneEditInput, editContactSaveButton } from "./editContactPopover";

export let topLevelContactList = JSON.parse(localStorage.getItem('contacts'));
export const contactListContainer = document.querySelector('#contact-list-container');
export const contactListEl = document.querySelector('#contact-list');
export const contactSearchInput = document.querySelector('#contact-search-input');
export const noResults = document.querySelector('#no-results');

export function initialiseContactList() {
    if (!localStorage.getItem('contacts') || !topLevelContactList.list) {
        localStorage.setItem('contacts', `{"list": []}`);
        topLevelContactList = JSON.parse(localStorage.getItem('contacts'));
        return;
    }

    addContactListIndices();

    if (topLevelContactList.list.length > 0) {
        contactListContainer.style.display = 'block';

        // topLevelContactList.list.forEach((contact) => {
        //     createContactMarkup(contact);
        // })
        renderContactList();
    }

    contactSearchInput.addEventListener('input', handleSearchInput);
}

function handleSearchInput() {
    let matches = 0;
    const contactEls = contactListEl.querySelectorAll('.contact-item');

    topLevelContactList.list.forEach((item) => {
        if (!item.name) { return }
        const nameText = item.name.toLowerCase();
        if (nameText.includes(contactSearchInput.value.toLowerCase())) {
            contactEls[item.index].classList.add('d-block');
            contactEls[item.index].classList.remove('d-none');
            matches++;
        } else {
            contactEls[item.index].classList.remove('d-block');
            contactEls[item.index].classList.add('d-none');
        }
    })
    if (matches === 0) {
        noResults.style.display = "block";
        contactListEl.style.display = 'none';
    } else {
        noResults.style.display = "none";
        contactListEl.style.display = 'block';
    }
}

export function createContactMarkup(contact) {
    // Parent div
    const parent = document.createElement('div');
    parent.classList.add('contact-item');
    parent.setAttribute('data-index', contact.index);

    // Lockup div
    const lockup = document.createElement('div');
    lockup.classList.add('d-flex', 'lockup');

    // Preview div
    const preview = document.createElement('div');
    preview.classList.add('align-center', 'flex-layout', 'nowrap', 'block-link', 'pos-r', 'bl-accent');

    // Name div
    const name = document.createElement('div');
    name.innerText = contact.name;
    name.classList.add('lh-1-4', 'line-clamp', 'lc-1');

    // Btn group
    const btnGroup1 = document.createElement('div');
    btnGroup1.classList.add('btn-group', 'fg-none', 'lmw-10', 'gap-3xs', 'row-gap-3xs', 'justify-end');

    const btnGroup2 = document.createElement('div');
    btnGroup2.classList.add('btn-group', 'fg-none', 'lmw-10', 'gap-3xs', 'row-gap-3xs', 'justify-end');

    // View btn
    const viewBtn = document.createElement('button');
    viewBtn.setAttribute('data-index', contact.index);
    viewBtn.setAttribute('aria-label', "open view/edit contact details");
    viewBtn.addEventListener('click', () => {
        let currentlyOpen = true;
        if (deets.classList.contains('d-none')) {
            currentlyOpen = false;
        }
        renderContactList();

        const newList = contactListEl.querySelectorAll('.contact-item');

        newList.forEach((item) => {
            if (item.getAttribute('data-index') != contact.index) {
                item.querySelector('.deets').classList.add('d-none');
            }
        })

        if (currentlyOpen === true) {
            newList[contact.index].querySelector('.deets').classList.add('d-none');
        } else {
            newList[contact.index].querySelector('.deets').classList.remove('d-none');
        }
    })

    // Delete btn
    const deleteBtn = document.createElement('button');
    deleteBtn.classList.add('btn', 'iconBtn', 'uiBtn', 'borderBtn');
    deleteBtn.setAttribute('aria-label', "delete contact");
    deleteBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="1.5"> <path d="M4 7l16 0"></path> <path d="M10 11l0 6"></path> <path d="M14 11l0 6"></path> <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path> <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path> </svg> `;
    deleteBtn.addEventListener('click', () => {
        deleteContact(contact.index);
    });

    // Deets
    const deets = document.createElement('div');
    deets.classList.add('d-none', 'deets');
    deets.innerHTML = `
    <div class="grid-layout lmw-14 scheme2 p-sm b-t">
        <div>
            <label for="contact-${contact.index}-name">Name</label>
            <input type="text" name="Name" id="contact-${contact.index}-name">
        </div>
        <div>
            <label for="contact-${contact.index}-email">Email</label>
            <input type="email" name="email" id="contact-${contact.index}-email">
        </div>
    </div>
    `

    const deetInputs = deets.querySelectorAll(':where(input, textarea)');
    deetInputs.forEach((deetInput) => {
        deetInput.addEventListener('input', handleDeetInput);
    })
    deetInputs[0].value = contact.name;
    deetInputs[1].value = contact.email;

    function handleDeetInput() {
        const contactObject = {};
        contactObject.name = deetInputs[0].value;
        contactObject.email = deetInputs[1].value;

        name.innerText = deetInputs[0].value;

        topLevelContactList.list[contact.index] = contactObject;
        updateContactList(false);
    }


    // Appends
    parent.append(lockup);
    lockup.append(preview, btnGroup2);
    preview.append(name);
    btnGroup1.append(viewBtn);
    btnGroup2.append(deleteBtn);
    preview.append(btnGroup1);

    parent.append(deets);

    contactListEl.append(parent);
}

export function renderContactList() {
    if (topLevelContactList.list.length < 1) {
        contactListContainer.style.display = 'none';
        return;
    }
    contactListContainer.style.display = 'block';

    contactListEl.querySelectorAll('.contact-item').forEach(item => item.remove());
    topLevelContactList.list.forEach((contact, i) => createContactMarkup(contact));
    handleSearchInput();
}

export function updateContactList(render = true) {
    addContactListIndices();
    localStorage.setItem('contacts', JSON.stringify(topLevelContactList));
    if (render) {
        renderContactList();
    }
    if (topLevelContactList.list.length === 0) {
        downloadListButton.setAttribute('disabled', true);
        return;
    }

    if (topLevelContactList.list.length > 0) {
        downloadListButton.removeAttribute('disabled');
    }
}

export function addContactListIndices() {
    topLevelContactList.list.forEach((contact, i) => contact.index = i);
}

function deleteContact(i) {
    topLevelContactList.list.splice(i, 1);
    updateContactList();
}